import { render, staticRenderFns } from "./GradeList.vue?vue&type=template&id=59ecb774&scoped=true"
import script from "./GradeList.vue?vue&type=script&lang=js"
export * from "./GradeList.vue?vue&type=script&lang=js"
import style0 from "./GradeList.vue?vue&type=style&index=0&id=59ecb774&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ecb774",
  null
  
)

export default component.exports